package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initUpload_unarchive_errorsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/upload_unarchive_errors.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/upload-unarchive-errors")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Upload_unarchive_errorsPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("upload-unarchive-errors") }) {
        org.jetbrains.compose.web.dom.Text("Upload / Unarchive Errors")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You might get an error while trying to upload or unarchive files on the server. Here are some possible causes:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The maximum upload size is 100MB, and what you are uploading exceeds that size. If you are using a Node.js server, you do not need to include the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("node_modules")
            }
            org.jetbrains.compose.web.dom.Text(" folder or the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("package-lock.json")
            }
            org.jetbrains.compose.web.dom.Text(" file in your archive. Just keep the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("package.json")
            }
            org.jetbrains.compose.web.dom.Text(" file, which the server uses to install packages.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The server may have a network issue while the upload is in progress. In this case, there is not much you can do other than try again after a few minutes or upload the files over SFTP. More information about SFTP and how to connect with it can be found ")
            com.varabyte.kobweb.silk.components.navigation.Link("/hosting_in_bot_hosting_net/connect-to-your-servers-files-with-sftp") {
                org.jetbrains.compose.web.dom.Text("here")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.WARNING, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" If you are using ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text(".rar")
            }
            org.jetbrains.compose.web.dom.Text(" archives, please switch to ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text(".zip")
            }
            org.jetbrains.compose.web.dom.Text(" or ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text(".tar.gz")
            }
            org.jetbrains.compose.web.dom.Text(", as ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text(".rar")
            }
            org.jetbrains.compose.web.dom.Text(" may generate issues while unarchiving.")
        }
    }
}
